import Swiper, {Navigation, Grid} from "swiper"

export default (el) => {
  const swiperEl = el.querySelector('.js-featured-category')

  new Swiper(swiperEl, {
    modules: [Navigation, Grid],
    slidesPerView: 3,
    grid: {
      rows: 2,
      fill: 'row',
    },
    spaceBetween: 10,
    navigation: {
      nextEl: ".featured-next",
      prevEl: ".featured-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 2.3,
        navigation: false,
        grid: false
      },
      992: {
        slidesPerView: 3.3,
        grid: false
      },
      1200: {
        slidesPerView: 6,
        spaceBetween: 16,
        grid: false
      }
    },
  })
}
